import Cookies from 'js-cookie';
import { v4 as uuidv4 } from 'uuid';
import { OPENAI_PIXEL_ID, OPPREF_COOKIE } from '../core/constants';
import { analyticsMinorUnitsFromPrice } from '../core/utils/stripeCurrencyAmounts';
import { sendLockerStudioData } from './lockerStudio';

export const getOppref = () =>
  new URLSearchParams(window.location.search).get('oppref') || Cookies.get(OPPREF_COOKIE);

export const sendOpenAIEvent = (eventName: string, eventData: object, eventId: string) => {
  window.oaiq?.('measure', eventName, eventData, { event_id: eventId });
};

export const sendOpenAIPageViewed = (oppref: string, appDomain: string) => {
  if (!OPENAI_PIXEL_ID) return;

  const eventId = uuidv4();

  sendOpenAIEvent('page_viewed', { type: 'contents' }, eventId);
  sendLockerStudioData('page_viewed', {
    openai_pixel_id: OPENAI_PIXEL_ID,
    oai_event_id: eventId,
    oppref,
    app_domain: appDomain,
  });
};

// Amount in minor units, the same as the backend takes from Stripe:
// x100 for most currencies, as is for zero-decimal ones (e.g. PYG).
// HUF is x100 (fillér), while our analytics helper treats it as zero-decimal.
// Three-decimal currencies (KWD, BHD...) are not handled, we don't sell in them.
const toOpenAIAmount = (price: number, currency: string) =>
  currency.toUpperCase() === 'HUF'
    ? Math.round(price * 100)
    : analyticsMinorUnitsFromPrice(price, currency);

export const sendOpenAISubscriptionCreated = (
  plan: string,
  price: number,
  currency: string,
  eventId: string,
) => {
  sendOpenAIEvent(
    'subscription_created',
    {
      type: 'plan_enrollment',
      plan_id: plan,
      amount: toOpenAIAmount(price, currency),
      currency,
    },
    eventId,
  );
};
